import * as css from "./app.less";

import { Sha256 } from "@aws-crypto/sha256-browser";

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);

window.Alpine = Alpine;

const API_ENDPOINT = process.env.API_ENDPOINT || ""; //"http://127.0.0.1:3000";
const EMAIL_PATTERN =
    /(^|[\s(\uFF08])([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})(?=$|[\s),.!?;:\uFF09\uFF0C\u3002\uFF1B\uFF1A])/gi;

function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, (char) => {
        const htmlEscapes = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
        };

        return htmlEscapes[char];
    });
}

function linkifyEmailAddresses(value) {
    return value.replace(
        EMAIL_PATTERN,
        '$1<a href="mailto:$2" class="font-medium underline">$2</a>'
    );
}

function formatMaintenanceMessage(value) {
    return linkifyEmailAddresses(escapeHtml(value)).replace(/\r?\n/g, "<br />");
}

document.addEventListener("alpine:init", () => {
    //init
    //console.log("alpine init");

    // Maintenance notice - fetches from API
    Alpine.data("maintenanceNotice", () => ({
        visible: false,
        message: "",
        init() {
            fetch(API_ENDPOINT + "/bcs_api/maintenance_message")
                .then((res) => res.json())
                .then((data) => {
                    if (data.success && data.data && data.data.is_enabled) {
                        var lang =
                            typeof emlang !== "undefined" ? emlang : "en";
                        var messageText = "";

                        if (lang === "tc") {
                            messageText =
                                data.data.message_tc ||
                                data.data.message_en ||
                                "";
                        } else if (lang === "sc") {
                            messageText =
                                data.data.message_sc ||
                                data.data.message_en ||
                                "";
                        } else {
                            messageText = data.data.message_en || "";
                        }

                        this.message = formatMaintenanceMessage(messageText);

                        // Build schedule info
                        var start = data.data.scheduled_start_at || "";
                        var end = data.data.scheduled_end_at || "";
                        if (start && end) {
                            var startStr = new Date(
                                start + " UTC"
                            ).toLocaleString();
                            var endStr = new Date(
                                end + " UTC"
                            ).toLocaleString();
                            this.message =
                                this.message +
                                " <strong>" +
                                escapeHtml(startStr) +
                                " – " +
                                escapeHtml(endStr) +
                                "</strong>";
                        }

                        if (this.message) {
                            this.visible = true;
                        }
                    }
                })
                .catch(() => {});
        },
    }));

    //for file upload
    Alpine.data("fileManager", () => ({
        // waiting-input, uploading, done, success. fail
        status: "waiting-input",
        cardExpanded: null,
        file: null,
        filename: "",
        resultRegistrationNo: "",
        resultNameChinese: "",
        resultAddressEnglish: "",
        resultStartDate: "",

        files: [],
        filenames: [],
        filesTotal: 0,
        filesDone: 0,
        filesResultOrder: [],
        filesResultDict: {},
        filesResult: [],

        //Prevent the browser's default drag behavior, e.g. open file in browser
        onFileOver(e) {
            e.preventDefault();
            //console.log("onFileOver");
        },

        //main handle file upload
        onFileDrop(ev) {
            ev.preventDefault();
            this.files = [];

            if (ev.dataTransfer.items) {
                if (ev.dataTransfer.items.length < 1) {
                    if (emlang && emlang === "en") {
                        alert("Not a file. Please select a file.");
                        return false;
                    }
                    alert("不是檔案,請選擇一個檔案");
                    return false;
                }

                let hasFile = false;
                for (const key in ev.dataTransfer.items) {
                    const fileItem = ev.dataTransfer.items[key];

                    if (fileItem.kind === "file") {
                        hasFile = true;

                        const file = fileItem.getAsFile();
                        this.files.push(file);
                    }
                }

                if (!hasFile) {
                    if (emlang && emlang === "en") {
                        alert("Not a file. Please select a file.");
                        return false;
                    }
                    alert("不是檔案,請選擇一個檔案");
                    return false;
                }

                console.log(this.files);
                this.submitMultipleFile();
            } else {
                // Use DataTransfer interface to access the file(s)
                if (ev.dataTransfer.files.length < 1) {
                    if (emlang && emlang === "en") {
                        alert("Not a file. Please select a file.");
                        return false;
                    }
                    alert("不是檔案,請選擇一個檔案");
                    return false;
                }

                this.file = ev.dataTransfer.files[0];
                this.files = ev.dataTransfer.files;

                this.submitMultipleFile();
            }
        },

        onFileChange(event) {
            event.preventDefault();
            //console.log("onFileChange");
            if (event.target.files.length < 1) {
                return false;
            }

            this.file = event.target.files[0];
            this.files = event.target.files;
            this.submitMultipleFile();
        },

        submitMultipleFile() {
            this.filenames = [];
            this.status = "uploading";
            if (this.files.length < 0) {
                this.status = "waiting-input";
                return false;
            }
            if (this.files.length > 20) {
                if (emlang && emlang === "en") {
                    alert("Please select up to 20 files.");
                } else if (emlang && emlang === "tc") {
                    alert("請選擇最多20個檔案");
                } else if (emlang && emlang === "sc") {
                    alert("请最多选择20个文件");
                } else {
                    alert("Too many files. Please select up to 5 files.");
                }

                this.status = "waiting-input";
                return false;
            }
            this.filesTotal = this.files.length;
            this.filesDone = 0;

            for (const aFile of this.files) {
                this.filenames.push(aFile.name);

                //readFile
                const reader = new FileReader();
                reader.readAsArrayBuffer(aFile);
                reader.onload = async (event) => {
                    const fileContent = event.target.result;
                    let hex = await calcSha256(fileContent);

                    this.filesResultOrder[aFile.name] = hex;
                    //console.log(hex);

                    const options = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ hash: hex }),
                    };
                    //call api to validate the hash
                    fetch(API_ENDPOINT + "/bcs_api/verify", options)
                        .then((response) => response.json())
                        .then((data) => {
                            //console.log(data);
                            let fileRet = {};
                            if (data.success) {
                                //check in not cancel
                                fileRet.Filename = aFile.name;
                                fileRet.Status = "success";
                                fileRet.RegistrationNo =
                                    data.data.RegistrationNo || "";
                                fileRet.Name = data.data.NameChinese || "";
                                if (emlang && emlang === "en") {
                                    fileRet.Name = data.data.NameEnglish || "";
                                }
                                fileRet.AddressEnglish =
                                    data.data.AddressEnglish || "";
                                fileRet.StartDate = data.data.StartDate || "";
                                fileRet.EndDate = data.data.EndDate || "";
                                fileRet.GroupName = data.data.GroupName || "";

                                //fileRet.StartDate = "2025-11-09 15:38:00";
                                //fileRet.EndDate = "2025-11-09 15:37:00";

                                if (fileRet.StartDate) {
                                    //replace T and Z to space
                                    fileRet.StartDate =
                                        fileRet.StartDate.replace(
                                            "T",
                                            " "
                                        ).replace(".000Z", "");
                                    //add timezone
                                    let fileRetStartDateObj = new Date(
                                        fileRet.StartDate + " UTC"
                                    );
                                    let fileRetStartDateObjOffset =
                                        fileRetStartDateObj.getTimezoneOffset();
                                    fileRetStartDateObj = new Date(
                                        fileRetStartDateObj.getTime() -
                                            fileRetStartDateObjOffset * 60000
                                    );
                                    fileRet.StartDate = fileRetStartDateObj
                                        .toISOString()
                                        .replace("T", " ")
                                        .replace(".000Z", "");
                                }
                                if (fileRet.EndDate) {
                                    //replace T and Z to space
                                    fileRet.EndDate = fileRet.EndDate.replace(
                                        "T",
                                        " "
                                    ).replace(".000Z", "");
                                    //add timezone
                                    let fileRetEndDateObj = new Date(
                                        fileRet.EndDate + " UTC"
                                    );
                                    let fileRetEndDateObjOffset =
                                        fileRetEndDateObj.getTimezoneOffset();
                                    fileRetEndDateObj = new Date(
                                        fileRetEndDateObj.getTime() -
                                            fileRetEndDateObjOffset * 60000
                                    );
                                    fileRet.EndDate = fileRetEndDateObj
                                        .toISOString()
                                        .replace("T", " ")
                                        .replace(".000Z", "");
                                    console.log(
                                        "Adjusted EndDate: " + fileRet.EndDate
                                    );
                                }

                                fileRet.NameChinese =
                                    data.data.NameChinese || "";
                                fileRet.NameEnglish =
                                    data.data.NameEnglish || "";

                                fileRet.StatusError = "";

                                //
                                if (data.revokedStatus) {
                                    fileRet.StatusError = "revoked"; //StatusError expired revoked not_found.
                                    fileRet.Status = "fail";
                                } else {
                                    //check if expired
                                    //check start date
                                    if (fileRet.StartDate) {
                                        let startDate = new Date(
                                            fileRet.StartDate
                                        );
                                        let now = new Date();
                                        if (startDate > now) {
                                            fileRet.StatusError = "not_found"; //StatusError expired revoked not_found. or not_effective
                                            fileRet.Status = "fail";
                                        }
                                    } else {
                                        fileRet.StatusError = "not_found"; //StatusError expired revoked not_found. or not_effective
                                        fileRet.Status = "fail";
                                    }
                                    //check end date
                                    if (fileRet.EndDate) {
                                        let endDate = new Date(fileRet.EndDate);
                                        let now = new Date();
                                        if (endDate < now) {
                                            fileRet.StatusError = "expired"; //StatusError expired revoked not_found.
                                            fileRet.Status = "fail";
                                        }
                                    }
                                }
                            } else {
                                fileRet.Filename = aFile.name;
                                fileRet.Status = "fail";
                                fileRet.RegistrationNo = "";
                                fileRet.Name = "";
                                fileRet.AddressEnglish = "";
                                fileRet.StartDate = "";
                                fileRet.StatusError = "";
                            }
                            this.filesResultDict[aFile.name] = fileRet;

                            this.filesDone++;
                            //check in not cancel
                            if (this.status == "uploading") {
                                if (this.filesDone >= this.filesTotal) {
                                    this.showResult();
                                }
                            }
                        })
                        .catch((error) => {
                            let fileRet = {};
                            fileRet.Filename = aFile.name;
                            fileRet.Status = "fail";
                            fileRet.RegistrationNo = "";
                            fileRet.Name = "";
                            fileRet.AddressEnglish = "";
                            fileRet.StartDate = "";
                            this.filesResultDict[aFile.name] = fileRet;

                            if (this.status == "uploading") {
                                if (this.filesDone >= this.filesTotal) {
                                    this.showResult();
                                }
                            }

                            console.error(error);
                        });
                    // setTimeout(() => {
                    //     this.status = "success";
                    // }, 1000);
                };
            }
        },
        showResult() {
            this.filesResult = [];
            for (const key in this.filenames) {
                let stringName = this.filenames[key];
                let dict = this.filesResultDict[stringName];
                if (dict) {
                    this.filesResult.push(dict);
                }
            }

            this.status = "done";

            //check if single file, show single file result success or fail

            if (this.filesResult.length == 1) {
                let fileRet = this.filesResult[0];
                if (fileRet.Status == "success") {
                    this.status = "success";
                } else {
                    this.status = "fail";
                }
            }
        },
        submit() {
            this.status = "uploading";
            if (this.file === null) {
                return false;
            }
            this.filename = this.file.name;
            const reader = new FileReader();
            reader.readAsArrayBuffer(this.file);
            reader.onload = async (event) => {
                const fileContent = event.target.result;
                let hex = await calcSha256(fileContent);

                //console.log(hex);

                const options = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ hash: hex }),
                };
                //call api to validate the hash
                fetch(API_ENDPOINT + "/api/verify", options)
                    .then((response) => response.json())
                    .then((data) => {
                        //console.log(data);
                        if (data.success) {
                            //check in not cancel
                            if (this.status == "uploading") {
                                this.status = "success";
                                this.resultRegistrationNo =
                                    data.data.RegistrationNo || "";
                                this.resultNameChinese =
                                    data.data.NameChinese || "";
                                this.resultAddressEnglish =
                                    data.data.AddressEnglish || "";
                                this.resultStartDate =
                                    data.data.StartDate || "";
                            }
                        } else {
                            if (this.status == "uploading") {
                                this.status = "fail";
                                this.resultRegistrationNo = "";
                                this.resultNameChinese = "";
                                this.resultAddressEnglish = "";
                                this.resultStartDate = "";
                            }
                        }
                    })
                    .catch((error) => console.error(error));
                // setTimeout(() => {
                //     this.status = "success";
                // }, 1000);
            };
        },

        reset() {
            this.status = "waiting-input";
            this.filename = "";
            this.resultRegistrationNo = "";
            this.resultNameChinese = "";
            this.resultAddressEnglish = "";
            this.resultStartDate = "";
            const fileInput = document.getElementById("filef");
            fileInput.value = null;
        },
        isErrorNotFound(dateString) {
            return (
                dateString != "expired" && dateString != "revoked" // && dateString != "not_effective"
            );
        },

        isErrorExpired(dateString) {
            return dateString == "expired";
        },
        isErrorRevoked(dateString) {
            return dateString == "revoked";
        },
        isErrorNotEffective(dateString) {
            return dateString == "not_effective";
        },
    }));
});

Alpine.start();

async function calcSha256(txt) {
    const hash = new Sha256();
    hash.update(txt);
    const result = await hash.digest();
    //let decoder = new TextDecoder('utf-8');
    //let string = decoder.decode(result);

    //const uint8array = new Uint8Array([10, 20, 30, 40, 50]);
    const hexString = Array.from(result)
        .map((byte) => ("0" + byte.toString(16)).slice(-2))
        .join("");

    //console.log(result.toString());
    //console.log(hexString);
    return hexString;
}

//console.log(calcSha256("txt"));
